import Area from '../domain/entities/Area';
import Merchant from '../domain/entities/Merchant';
import MerchantCategory from '../domain/entities/MerchantCategory';
import { MerchantBookingData } from '../interfaces/merchants/bookings';

export interface BreadCrumbsProps {
  breadcrumbs: Array<{ url: string; text: string }>;
}

export function buildBreadCrumbs(
  merchant: Merchant,
  area?: Area,
  category?: MerchantCategory,
  merchantTab?: { path: string; text: string } | undefined,
  resource?: MerchantBookingData,
): Array<{ url: string; text: string }> {
  const breadcrumbs = [{ url: '/', text: 'ホーム' }];

  if (category) {
    breadcrumbs.push({
      url: `/categories/${category.id}`,
      text: category.nameJA,
    });
  }

  if (category && area && area.parentArea) {
    breadcrumbs.push({
      url: `/categories/${category.id}/areas/${area.parentArea.id}`,
      text: `${area.parentArea.localName}`,
    });
  }

  if (category && area) {
    breadcrumbs.push({
      url: `/categories/${category.id}/areas/${area.id}`,
      text: `${area.localName}`,
    });
  }

  breadcrumbs.push({
    url: `/${merchant.publicId}`,
    text: merchant.displayName,
  });

  if (merchantTab) {
    breadcrumbs.push({
      url: `/${merchant.publicId}/${merchantTab.path}`,
      text: merchantTab.text,
    });
  }

  if (resource) {
    breadcrumbs.push({
      url: `/${merchant.publicId}/${resource.public_id}`,
      text: resource.name,
    });
  }

  return breadcrumbs;
}
